import nodeClient from "./node-client";

export const addFrequencySlab = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/frequncy/add`,
    payload
  );
  return response?.data;
};

export const fetchFrequencySlabDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/frequncy/findOne?${query}`
  );
  return response?.data;
};
